import {Text} from 'native-base';
import React from 'react';

import {theme} from '../../../theme';

interface PRDescriptionProps {
  children?: string | string[];
  isValid: boolean;
  bulleted?: boolean;
  testID: string;
}
const PRDescription: React.FC<PRDescriptionProps> = (props) => {
  const {children, isValid, bulleted = false, testID} = props;
  const {paleSky} = theme.colors;
  return (
    <Text
      fontSize="14px"
      lineHeight="20px"
      fontFamily="heading"
      fontWeight={400}
      color={isValid ? '#008143' : paleSky}
      testID={`${testID}-description`}
    >
      {bulleted ? '  • ' : null} {children}
    </Text>
  );
};

export default PRDescription;
